import React, { createContext, useContext, useEffect, useState } from "react";
import { REGIONS } from "@/lib/api";

const RegionContext = createContext({ region: "mid", setRegion: () => {} });

export const RegionProvider = ({ children }) => {
  const [region, setRegionState] = useState(() => {
    if (typeof window === "undefined") return "mid";
    const saved = window.localStorage.getItem("td_region");
    return REGIONS.find((r) => r.key === saved) ? saved : "mid";
  });

  useEffect(() => {
    window.localStorage.setItem("td_region", region);
  }, [region]);

  return (
    <RegionContext.Provider value={{ region, setRegion: setRegionState }}>{children}</RegionContext.Provider>
  );
};

export const useRegion = () => useContext(RegionContext);

export const priceFor = (service, region) => service.pricing?.[region] ?? service.pricing?.mid ?? 0;
